var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2497 18.625C20.1838 18.739 20.0891 18.8337 19.9751 18.8996C19.861 18.9654 19.7317 19 19.6 19H1.59997C1.46838 18.9999 1.33915 18.9651 1.22524 18.8992C1.11133 18.8334 1.01676 18.7387 0.951027 18.6247C0.885292 18.5107 0.850705 18.3814 0.850739 18.2498C0.850772 18.1182 0.885426 17.989 0.95122 17.875C2.37903 15.4066 4.57934 13.6366 7.14716 12.7975C5.877 12.0414 4.89017 10.8892 4.33821 9.51793C3.78625 8.14667 3.69967 6.63213 4.09179 5.2069C4.4839 3.78167 5.33302 2.52456 6.50874 1.62862C7.68447 0.73268 9.12178 0.247452 10.6 0.247452C12.0782 0.247452 13.5155 0.73268 14.6912 1.62862C15.8669 2.52456 16.716 3.78167 17.1082 5.2069C17.5003 6.63213 17.4137 8.14667 16.8617 9.51793C16.3098 10.8892 15.3229 12.0414 14.0528 12.7975C16.6206 13.6366 18.8209 15.4066 20.2487 17.875C20.3147 17.9889 20.3495 18.1182 20.3497 18.2499C20.3498 18.3815 20.3153 18.5109 20.2497 18.625Z",
    fill: "#32C9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.811c59e57b9fdfae2cac2416d9af55be.svg";
export { ForwardRef as ReactComponent };